import { render, staticRenderFns } from "./PropertyHeadlineForm.vue?vue&type=template&id=6a316259&scoped=true&"
import script from "./PropertyHeadlineForm.vue?vue&type=script&lang=js&"
export * from "./PropertyHeadlineForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a316259",
  null
  
)

export default component.exports